import React from "react";

const Companies = () => {
  return (
    <>
      <div
        id="top companies"
        className="w-full flex justify-center py-12 xl:px-12 px-4"
      >
        <div className="w-full max-w-[85rem]">
          <div className="w-full text-center">
            <h4 className="text-base font-medium">A Track Record of Success</h4>
            <h1 className="text-2xl md:text-3xl mt-2 font-semibold capitalize">
              Our <span className="text-universal">Students</span> Thrive in{" "}
              <span className="text-universal">Top-tier</span> Professions
            </h1>
          </div>
          <div className="w-full hidden md:flex justify-center mt-12">
            <img
              className="w-full max-w-7xl"
              src="https://storage.googleapis.com/accredian-assets/Frontend_Assests/Images/Accredian-react-site-images/other/companies.webp"
              alt="companies"
            />
          </div>
          <div className="w-full flex md:hidden justify-center mt-8">
            <img
              className="w-full max-w-7xl"
              src="https://storage.googleapis.com/accredian-assets/Frontend_Assests/Images/Accredian-react-site-images/other/companies-res.webp"
              alt="companies-res"
            />
          </div>
        </div>
      </div>
      <p className={`italic p-3 text-center  font-medium`}>
        <span className="font-semibold">*Note:</span> All product and company names are trademarks or
        registered trademarks of their respective holders, use of them does not
        imply any affiliation with or endorsement by them.
      </p>
    </>
  );
};

export default Companies;
